import React from "react";
import { Routes, Route } from 'react-router-dom';

import Signup from './../Pages/Auth/Signup';
import Signin from './../Pages/Auth/Signin';
import ForgotPassword from './../Pages/Auth/ForgotPassword';
import ResetPassword from './../Pages/Auth/ResetPassword';

const Auth = () =>{

    return(
    <Routes>
        <Route path="/" element={<Signin />} >
            <Route path="sign-in" element={<Signin />} />
        </Route>

        <Route path="sign-up" element={<Signup />} />
        <Route path="forgot-password" element={<ForgotPassword />} />
        <Route path="reset-password" element={<ResetPassword />} />
    </Routes>
    );
}

export default Auth;